import { Status } from "@shared/enums";
import { CommonEditContext, CreateCommonSearchContext } from "./common-data.model";

export const DefaultSafety = {
  search: CreateCommonSearchContext(),
  edit: {
    editForm: {
      model: {} as SafetyEditCriteria,
      dirty: false,
      status: null as any,
      errors: null as any
    },
  } as CommonEditContext<SafetyEditCriteria>,
}

export interface SafetyEditCriteria {
  status: Status;
  kpiSaftyComment: string;
}
